/**
 * goldStandard_Max_FieldLengths_Constants.ts
 *
 *    Keep in sync with Java class FieldLengthConstants
 */

export class GoldStandard_Max_FieldLengths_Constants {

    static readonly GOLD_STANDARD_MAX_LENGTH__DISPLAY_LABEL = 8; // DB: 300
    static readonly GOLD_STANDARD_MAX_LENGTH__DESCRIPTION = 255; // DB: 5000
}

